import React, { ElementType } from 'react';
import SearchListItem from '../SearchBar/SearchListItem';
import { SpaceUser } from '../../Conversion.types';
import { Box } from '@ublend-npm/aulaui-core';
import { createStyles } from './UsersList.styles';

type UsersListProps = {
  users?: SpaceUser[];
  selectedUsers?: SpaceUser[];
  actionIcon?: ElementType | null;
  tooltip?: string;
  onActionClick?: (user: SpaceUser) => void;
  disabledText?: string;
};

const UsersList = ({
  users = [],
  onActionClick = () => {},
  actionIcon = null,
  tooltip = '',
  selectedUsers = [],
  disabledText = '',
}: UsersListProps) => {
  const styles = createStyles();

  return (
    <Box
      role="list"
      aria-label="Students assigned to this extension"
      sx={styles.list}
    >
      {users?.map((user) => {
        const { id, fullName, avatar, email, userActionDisabled } = user;

        const isAdded = selectedUsers.some(
          (selectedUser) => selectedUser.id === id
        );

        const showActionIcon = !isAdded && actionIcon;
        return (
          <SearchListItem
            key={id}
            fullName={fullName}
            email={email}
            avatar={avatar}
            userAdded={isAdded}
            isDisabled={userActionDisabled}
            disabledText={userActionDisabled ? disabledText : undefined}
            actionIcon={showActionIcon ? actionIcon : null}
            tooltip={tooltip}
            onActionClick={
              !userActionDisabled ? () => onActionClick(user) : undefined
            }
            styles={{
              rootSx: styles.listItemRoot,
            }}
          />
        );
      })}
    </Box>
  );
};

export default React.memo(UsersList);
